import { Pipe, PipeTransform } from '@angular/core';
import {EnumValidValueItemModel} from '../models/enum/enum-valid-value-item.model';

@Pipe({
  name: 'enumDisplay'
})
export class EnumDisplayPipe implements PipeTransform {


  transform(enums: EnumValidValueItemModel[], filterValue: string): any {
    if (!enums || !filterValue) {
      return enums;
    }
    return enums.filter(enumValue => enumValue.ValidValueItemId === filterValue);
  }

}



